import type { AddOnCatalogItem } from '@/types/addons';

// Curated add-ons catalog for the Montana demo (scales later to global catalog)
export const MONTANA_ADDONS_CATALOG: AddOnCatalogItem[] = [
  {
    id: 'analog-to-digital-assessment',
    name: 'Analog-to-Digital Assessment',
    shortLabel: 'Assessment',
    description:
      'A scoping session and review to estimate work for converting paper or unstructured files into organized digital records. This helps produce an accurate migration quote.',
    pricingModel: 'fixed-setup',
    price: 500,
    unit: 'setup',
    applicableTiers: ['silver', 'gold'],
    tags: ['montana-recommended'],
    badge: 'Required to scope migration',
  },
  {
    id: 'data-migration',
    name: 'Data Migration (Digital Organization)',
    shortLabel: 'Migration',
    description:
      'We organize and integrate your provided digital files into the platform. Every community has unique data organization levels - from highly organized to completely disorganized. Scope and pricing depend on data volume, organization state, and technical complexity. We provide secure data portals for file transfer and our data engineering staff handles the integration process. More organized communities = faster, lower-cost migration.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold'],
    tags: ['montana-recommended', 'data'],
    badge: 'Time & complexity dependent',
  },
  {
    id: 'governance-mirroring',
    name: 'Governance Mirroring Setup',
    shortLabel: 'Governance',
    description: 'Mirror boards, committees, cadence, and roles for a turnkey start.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold'],
    tags: ['governance', 'legacy-support'],
  },
  {
    id: 'us-only-data-storage',
    name: 'US-Only Data Storage & Processing',
    shortLabel: 'US Storage',
    description:
      'Ensure all your community data is stored and processed exclusively within United States data centers. Pricing varies based on usage patterns and storage requirements; scope is quoted per community.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold'],
    tags: ['infrastructure', 'compliance'],
    badge: 'Usage-dependent pricing',
  },
  {
    id: 'enhanced-security-compliance',
    name: 'Enhanced Security & Compliance Package',
    shortLabel: 'Security+',
    description:
      'Advanced security features including enhanced audit trails and additional compliance monitoring. Ideal for communities with strict regulatory requirements. Formal third-party attestations are not included; scope is quoted per community.',
    pricingModel: 'quote',
    applicableTiers: ['gold'],
    tags: ['infrastructure', 'compliance'],
    badge: 'Enterprise feature',
  },
  {
    id: 'advanced-backup-retention',
    name: 'Advanced Backup & Retention',
    shortLabel: 'Backup+',
    description:
      'Extended backup retention (7+ years) for communities with long-term record requirements. Costs depend on data volume and retention requirements; scope is quoted per community.',
    pricingModel: 'quote',
    applicableTiers: ['gold'],
    tags: ['infrastructure', 'compliance'],
    badge: 'Volume-dependent pricing',
  },
  {
    id: 'sso-integration',
    name: 'Single Sign-On (SSO) Integration',
    shortLabel: 'SSO',
    description:
      'Tell us which identity provider your organization uses. We will scope feasibility and provide a quote before any work begins.',
    pricingModel: 'quote',
    applicableTiers: ['gold'],
  },
  {
    id: 'custom-integrations',
    name: 'Custom Integrations',
    shortLabel: 'Integrations',
    description:
      'Tell us what you need connected. We will scope feasibility and provide a quote before any work begins.',
    pricingModel: 'quote',
    applicableTiers: ['silver', 'gold'],
    tags: ['development'],
    badge: 'Scoped per request',
  },
];
